// extracted by mini-css-extract-plugin
module.exports = {"recordbtns":"recordbtn_recordbtns__1lah7"};